/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_plot_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste your data above to draw the chart.`)
};

const es_plot_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega tus datos arriba para dibujar el gráfico.`)
};

const de_plot_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie oben Ihre Daten ein, um das Diagramm zu zeichnen.`)
};

const nl_plot_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak hierboven je data om de grafiek te tekenen.`)
};

const fr_plot_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez vos données ci-dessus pour tracer le graphique.`)
};

const it_plot_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla i tuoi dati sopra per disegnare il grafico.`)
};

const pt_br2_plot_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole seus dados acima para desenhar o gráfico.`)
};

const pt_plot_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole os seus dados acima para desenhar o gráfico.`)
};

const ja_plot_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上にデータを貼り付けるとグラフが描画されます。`)
};

const zh_plot_hint_empty = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在上方粘贴数据以绘制图表。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const plot_hint_empty = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.plot_hint_empty(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("plot_hint_empty", locale)
	if (locale === "en") return en_plot_hint_empty(inputs)
	if (locale === "es") return es_plot_hint_empty(inputs)
	if (locale === "de") return de_plot_hint_empty(inputs)
	if (locale === "nl") return nl_plot_hint_empty(inputs)
	if (locale === "fr") return fr_plot_hint_empty(inputs)
	if (locale === "it") return it_plot_hint_empty(inputs)
	if (locale === "pt-BR") return pt_br2_plot_hint_empty(inputs)
	if (locale === "pt") return pt_plot_hint_empty(inputs)
	if (locale === "ja") return ja_plot_hint_empty(inputs)
	return zh_plot_hint_empty(inputs)
};